import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from 'react';
import { updatePermissions } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Permissions } from './PermissionsColumns'
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';

const { Option } = Select

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showUpdatePermissionDrawer: boolean;
    setShowUpdatePermissionDrawer: React.Dispatch<React.SetStateAction<boolean>>
    permissions: Permissions
    getPermissions: any
    setPermissionData: React.Dispatch<React.SetStateAction<Permissions | undefined>>
}
const UpdatePermissionDrawer: React.FC<ProductsDrawerProps> = ({ showUpdatePermissionDrawer, setShowUpdatePermissionDrawer, permissions, getPermissions, setPermissionData }) => {
    const onCLose = () => {
        setPermissionData(undefined)
        setShowUpdatePermissionDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();

    const onFinish = (permissions: Permissions) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.put(`/api/v1/permissions/${permissions.id}`, permissions, {
            signal: controller.signal
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "permission successfully updated",
                    `${permissions.name} was updated`,
                    'topRight'
                )
            }
            getPermissions()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return (
        <>

            <Drawer
                title="update Permissions"
                width={720}
                onClose={onCLose}
                open={showUpdatePermissionDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical"
                    onFinishFailed={onFinishFailed}
                    onFinish={onFinish}
                    form={form}
                    initialValues={permissions}
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="name"
                                label="name"
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="id"
                                label="id"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {submitting && <Spin indicator={antIcon} />}
                    </Row>
                </Form>
            </Drawer>
        </>
    )
}

export default UpdatePermissionDrawer


